export default {"src":"/_next/static/media/illustration-ancient-rome.32822203.svg","height":120,"width":103};